import { intercepter, mock } from '../config';

mock.mock(/\/user\/logout\/mock*/, 'post', intercepter(null, null));
